import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const CurrentIcon = () => {
    return (
        <SvgIcon viewBox="0 0 36 36">
            <circle cx="18" cy="18" r="5" fill="white"/>
        </SvgIcon>
    );
}